import React from 'react';

const leerValor = (datos, path, key) => {
  if (!datos) {
    return '';
  }
  if (!path) {
    return datos[key] || '';
  }
  return (datos[path] && datos[path][key]) || '';
};

const InformePlantillaForm = ({
  titulo,
  pacienteNombre,
  secciones,
  datos,
  onChange,
  onGuardar,
  onCancelar,
  guardando,
}) => {
  const escribir = (path, key, value) => {
    if (!path) {
      onChange({ ...datos, [key]: value });
      return;
    }
    onChange({
      ...datos,
      [path]: {
        ...(datos[path] || {}),
        [key]: value,
      },
    });
  };

  const renderControl = (config, value, onInput) => {
    const tipo = config.tipo || (config.rows ? 'multilinea' : 'linea');
    if (tipo === 'fecha') {
      return (
        <input
          type="date"
          className="informes-plantilla-input"
          value={value || ''}
          onChange={(event) => onInput(event.target.value)}
        />
      );
    }
    if (tipo === 'multilinea') {
      return (
        <textarea
          className="informes-plantilla-textarea"
          rows={config.rows || 4}
          maxLength={config.maxLength || 2000}
          value={value || ''}
          onChange={(event) => onInput(event.target.value)}
        />
      );
    }
    return (
      <input
        type="text"
        className="informes-plantilla-input"
        maxLength={config.maxLength || 120}
        value={value || ''}
        onChange={(event) => onInput(event.target.value)}
      />
    );
  };

  return (
    <div className="informes-plantilla">
      <p className="informes-plantilla-paciente">
        Paciente: <strong>{pacienteNombre || '—'}</strong>
      </p>
      <p className="informes-plantilla-badge">{titulo}</p>

      {(secciones || []).map((sec) => (
        <section key={sec.titulo} className="informes-plantilla-section">
          <h4>{sec.titulo}</h4>
          <div
            className={
              sec.grid === 'datos'
                ? 'informes-plantilla-grid informes-plantilla-grid--datos'
                : 'informes-plantilla-grid'
            }
          >
            {(sec.campos || []).map((campo) => (
              <label key={`${sec.path || 'root'}-${campo.key}`} className="informes-plantilla-field">
                <span>{campo.label}</span>
                {renderControl(campo, leerValor(datos, sec.path, campo.key), (value) =>
                  escribir(sec.path, campo.key, value)
                )}
              </label>
            ))}
          </div>
        </section>
      ))}

      <div className="informes-actions">
        <button
          type="button"
          className="informes-btn informes-btn--primary"
          onClick={onGuardar}
          disabled={guardando}
        >
          {guardando ? 'Guardando…' : 'Guardar'}
        </button>
        <button type="button" className="informes-btn informes-btn--ghost" onClick={onCancelar}>
          Volver
        </button>
      </div>
      <p className="informes-muted">
        Impresión PDF con firma digital: próximamente (igual que en Terapias).
      </p>
    </div>
  );
};

export default InformePlantillaForm;
